// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("bootstrap")
require("jquery")
require("inputmask")
require("channels")
require('./nested_forms/addFields')
require('./nested_forms/removeFields')
require('./placeholders/reload')
require("./invoices/form")
require("./invoices/select")
require("./invoices/e_invoice_upload")
require("./payments/form")
require("./header_menu")
require("./responsive_tables")
document.addEventListener("turbolinks:load", function () {
    if (typeof gtag === "function") {
        gtag("config", "G-YG83V1S5VK", {
            page_path: window.location.pathname
        });
    }
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
